import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import "./PaymentGateway.css";

class PaymentGateway extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: "",
      isLoading: true,
      bookingData: null,
      selectedPayment: "",
      agreedToTerms: false,
      isProcessing: false,
    };
  }

  //API_BASE = axios.defaults.baseURL;
  //PUBLIC_BASE = this.API_BASE ? this.API_BASE.replace("/api", "") : "";
  //PUBLIC_WEB_BASE = 'http://localhost:3000/';
  //PUBLIC_WEB_BASE = 'https://bookly.com.bd/';

  PUBLIC_WEB_BASE = axios.defaults.baseURL ? axios.defaults.baseURL.replace("/api", "") : "";

  componentDidMount() {
    this.fetchBookingData();
    this.fetchFooterData();
  }

  fetchFooterData = async () => {
    try {
      const res = await axios.get("/theme_customizable", {});
      const d = res?.data?.data;
      if (d) {
        this.setState({ phone: d.phone || "" });
      }
    } catch (error) {
      console.error("Footer fetch error:", error);
    }
    try {
      const res1 = await axios.get("/setting", {});
      const d = res1?.data?.data;
      if (d) {
        this.setState({ powered_by: d.powered_by || "" });
      }
    } catch (error) {
      console.error("Setting fetch error:", error);
    }
  };

  getBookingId = () => {
    return window.location.pathname.split("/payment/")[1];
  };

  formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  calculateDays = (checkin, checkout) => {
    const start = new Date(checkin);
    const end = new Date(checkout);
    return Math.ceil((end - start) / (1000 * 60 * 60 * 24)) || 1;
  };

  fetchBookingData = async () => {

    const id = this.getBookingId();

    try {

      const res = await axios.get(`/get_book_by_id?id=${id}`);
      const data = res.data.data;
      const days = this.calculateDays(data.checkin_date, data.checkout_date);

      const dynamicImage = data.image || data.featured_image || data.thumbnail || "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=800&q=80";

      const mappedData = {
        id: data.id,
        dates: `${this.formatDate(data.checkin_date)} - ${this.formatDate(data.checkout_date)}`,
        duration: `${days} day${days > 1 ? "s" : ""}`,
        guests: parseInt(data.adults || 0) + parseInt(data.kids || 0),
        expiresIn: "23:59:59",
        status: data.booking_status === "Confirmed" ? "Accepted" : "Failed",

        property: {
          title: data.post_title,
          image: dynamicImage,
          isNew: true,
          pricePerDay: Math.round(data.total_amount / days),
        },

        price: {
          base: Math.round(data.total_amount / days),
          days,
          discount: 0,
          total: parseFloat(data.total_amount),
          paid: data.payment_status === "Paid" ? parseFloat(data.total_amount) : 0,
          due: data.payment_status === "Paid" ? 0 : parseFloat(data.total_amount),
        },

        customer: data.full_name,
      };

      this.setState({
        bookingData: mappedData,
        isLoading: false,
      });
    } catch (error) {
      console.error(error);
      alert("Booking data fetch failed");
      this.setState({ isLoading: false });
    }
  };

  handlePaymentSelection = (method) => {
    this.setState({ selectedPayment: method });
  };

  handleCheckboxChange = (e) => {
    this.setState({ agreedToTerms: e.target.checked });
  };

  handleConfirmAndPay = async () => {
    const { bookingData, selectedPayment, agreedToTerms } = this.state;

    if (!agreedToTerms || !selectedPayment) return;

    this.setState({ isProcessing: true });

    try {
      const payload = {
        booking_id: bookingData.id,
        gateway: selectedPayment,
        product_name: bookingData.property.title,
        product_qty: bookingData.price.days,
        amount: bookingData.price,
        customer_name: bookingData.customer,
        success_url: `${this.PUBLIC_WEB_BASE}payment-success/${bookingData.id}`,
        fail_url: `${this.PUBLIC_WEB_BASE}payment-failed/${bookingData.id}`,
        cancel_url: `${this.PUBLIC_WEB_BASE}payment-cancel/${bookingData.id}`,
      };

      const res = await axios.post('/initiate_payment', payload);

      if (res.data.status === "success") {
        window.location.href = res.data.payment_url;
      } else {
        alert("Payment initialization failed");
      }

      this.setState({ isProcessing: false });
    } catch (error) {
      console.error(error);
      alert("Gateway connection failed");
      this.setState({ isProcessing: false });
    }
  };

  renderLeftPanel() {
    const { bookingData } = this.state;

    return (
      <div className="pg-left-panel">
        <div className="pg-card">
          <div className="pg-info-row">
            <div className="pg-label">
              <span className="pg-icon">📅</span>
              Dates
            </div>
            <div className="pg-value">
              <strong>{bookingData.dates}</strong>{" "}
              <span className="pg-text-muted">({bookingData.duration})</span>
            </div>
          </div>

          <div className="pg-info-row">
            <div className="pg-label">
              <span className="pg-icon">👤</span>
              Guests
            </div>
            <div className="pg-value">
              <strong>{bookingData.guests} Guest{bookingData.guests > 1 ? 's' : ''}</strong>
            </div>
          </div>

          <div className="pg-info-row">
            <div className="pg-label">
              <span className="pg-icon">⏳</span>
              Expires In
            </div>
            <div className="pg-value">
              <strong>{bookingData.expiresIn}</strong>
            </div>
          </div>

          <div className="pg-info-row pg-no-border">
            <div className="pg-label">
              <span className="pg-icon">✔️</span>
              Status
            </div>
            <div className={`pg-status-badge pg-status-${bookingData.status.toLowerCase()}`}>
              {bookingData.status}
            </div>
          </div>
        </div>

        <div className="pg-card">
          <h3 className="pg-card-title">
            <span className="pg-icon">✖️</span>
            Cancellation Policy
          </h3>
          <p className="pg-card-text pg-text-muted">
            - 80% of the total booking amount will be refunded if its cancelled 24 hours before the check in date.
          </p>
        </div>

        <div className="pg-card pg-warning-card">
          <h3 className="pg-card-title pg-text-dark">
            <span className="pg-icon">⚠️</span> Your reservation won't be confirmed.
          </h3>
          <p className="pg-card-text pg-text-muted">
            You won't be charged until the host accepts your request within 24 hours.
          </p>
        </div>

        <div className="pg-card">
          <h3 className="pg-card-title">
            <span className="pg-icon">📞</span> Contact Details
          </h3>
          <p className="pg-card-text pg-text-highlight">
            - Contact Number & Location will be provided once you Confirm & Pay.
          </p>
          <p className="pg-card-text pg-text-highlight">
            - "Confirm & Pay" বাটনে ক্লিক করে পেমেন্ট করার পর মোবাইল নাম্বার এবং লোকেশন দেয়া হবে।
          </p>
        </div>
      </div>
    );
  }

  renderRightPanel() {
    const { bookingData, selectedPayment, agreedToTerms, isProcessing } = this.state;
    const { property, price, status } = bookingData;

    return (
      <div className="pg-right-panel">
        <div className="pg-card pg-main-card">
          <div className="pg-property-header">
            {/* Dynamic Property Image Rendered Here */}
            <img src={property.image} alt="Property" className="pg-property-img" />
            <div className="pg-property-details">
              <h2 className="pg-property-title">{property.title}</h2>
              <div className="pg-property-meta">
                <span className="pg-star">★</span> New
              </div>
              <div className="pg-property-price">
                <span className="pg-text-pink">BDT {property.pricePerDay}</span> /day
              </div>
            </div>
          </div>

          <div className="pg-price-section">
            <h3 className="pg-section-title">Price Details</h3>
            <div className="pg-price-row">
              <span>BDT {price.base} × {price.days} days</span>
              <span>৳ {price.total}</span>
            </div>
            <div className="pg-price-row pg-total-row">
              <span>Total Payable</span>
              <span>৳ {price.total}</span>
            </div>
            <div className="pg-price-row">
              <span>Paid</span>
              <span>৳ {price.paid}</span>
            </div>
            <div className="pg-price-row pg-due-row">
              <span>Due</span>
              <span className="pg-text-pink">৳ {price.due}</span>
            </div>
          </div>

          <div className="pg-payment-section">
            <h3 className="pg-section-title">Select Payment Method</h3>
            
            <div className="pg-payment-grid">
              {/* Fixed bKash Option Image Link */}
              <div
                className={`pg-payment-option ${selectedPayment === "bkash" ? "pg-selected" : ""}`}
                onClick={() => this.handlePaymentSelection("bkash")}
              >
                <div className="pg-radio-circle"></div>
                <img
                  src="https://download.logo.wine/logo/BKash/BKash-Logo.wine.png"
                  alt="bKash"
                  className="pg-gateway-logo"
                />
                <span className="pg-gateway-name">bKash</span>
              </div>

              {/* Other Payment Methods Option */}
              <div
                className={`pg-payment-option ${selectedPayment === "others" ? "pg-selected" : ""}`}
                onClick={() => this.handlePaymentSelection("others")}
              >
                <div className="pg-radio-circle"></div>
                <span className="pg-gateway-emoji">💳</span>
                <span className="pg-gateway-name">Other Payment Methods</span>
              </div>
            </div>
          </div>

          <div className="pg-action-section">
            <label className="pg-terms-label">
              <input
                type="checkbox"
                checked={agreedToTerms}
                onChange={this.handleCheckboxChange}
              />
              <span className="pg-terms-text">
                I agree to the <a href="#terms">Terms & Conditions</a>
              </span>
            </label>

            <button
              className={status === "Failed" ? "pg-btn pg-btn-danger" : "pg-btn pg-btn-primary"}
              disabled={!agreedToTerms || !selectedPayment || isProcessing}
              onClick={this.handleConfirmAndPay}
            >
              {isProcessing
                ? "Processing..."
                : status === "Failed"
                ? "Retry Payment"
                : "Confirm & Pay"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { isLoading, bookingData } = this.state;

    if (isLoading || !bookingData) {
      return (
        <div className="pg-loading">
          <div className="pg-loading-spinner"></div>
          Loading payment details...
        </div>
      );
    }

    return (
      <div className="pg-wrapper">
        <div className="pg-container">
          {this.renderLeftPanel()}
          {this.renderRightPanel()}
        </div>
      </div>
    );
  }
}

export default PaymentGateway;
